import React from 'react';

import { Link as RouterLink } from '@tanstack/react-router';

import MuiLink from '@mui/material/Link';


const Link = React.forwardRef((props, ref) => {
  const { to, href, children, ...restProps } = props;
  if (to) {
    return (
      <MuiLink
        ref={ref}
        to={to}
        component={RouterLink}
        activeOptions={{ exact: true }}
        activeProps={{ className: 'Mui-active' }}
        {...restProps}
      >
        {children}
      </MuiLink>);
  }

  if (href) {
    return <MuiLink ref={ref} href={href} component="a" {...restProps}>{children}</MuiLink>;
  }

  throw new Error('Provide \'to\' or \'href\'.');
});

Link.displayName = 'Link';
export default Link;
